import { render } from "./AudienceFilter.vue?vue&type=template&id=0a8934c8&scoped=true"
import script from "./AudienceFilter.vue?vue&type=script&lang=ts"
export * from "./AudienceFilter.vue?vue&type=script&lang=ts"

import "./AudienceFilter.vue?vue&type=style&index=0&id=0a8934c8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0a8934c8"

export default script
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QItemSection,QTable,QTr,QTh,QTd,QItem});
